import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../api/verification.js";
import axiosInstance from '../utils/axios'; 
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Register.css";



// Adjust to your actual required field names in `formData`
const REQUIRED_FIELDS = ["email", "password"];

function getMissingFields(formData) {
  return REQUIRED_FIELDS.filter((field) => !String(formData[field] ?? "").trim());
}

// Categorizes a DRF error response into per-field errors vs a general banner message
function parseServerErrors(data) {
  if (!data) {
    return { fieldErrors: {}, generalMessage: "Something went wrong. Please try again." };
  }
  if (typeof data === "string") {
    return { fieldErrors: {}, generalMessage: data };
  }
  if (data.detail) {
    // e.g. throttling ("request was throttled"), auth errors, etc.
    return { fieldErrors: {}, generalMessage: data.detail };
  }

  const fieldErrors = {};
  let generalMessage = null;

  Object.entries(data).forEach(([key, value]) => {
    const message = Array.isArray(value) ? value[0] : value;
    if (key === "non_field_errors" || key === "__all__") {
      generalMessage = message;
    } else {
      fieldErrors[key] = message; // e.g. { username: "...", phone: "..." }
    }
  });

  return { fieldErrors, generalMessage };
}

function Register() {
  const [setlang, setLang] = useState("fa");
  const { lang } = useParams();
  const [status, setStatus] = useState(null);
  const [profilePicture, setProfilePicture] = useState(null);
  const [username, setUsername] = useState('');
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [errMessage, setErrMessage] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username:'',
    email: '',
    password: '',
    password2: '',
    accepted_tnc: '',
  });
  const [fieldErrors, setFieldErrors] = useState({});   // server-rejected fields (e.g. duplicate username)
  const [missingFields, setMissingFields] = useState([]); // client-caught empty required fields


  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    if (e.target.name==="email") {
      setFormData(prev => ({ ...prev, "username": e.target.value }));
    }
  };


  const handleImageChange = (e) => {
    if (e.target.files.length > 0) {
      setProfilePicture(e.target.files[0]); 
    }
  };

  const handleCheckBox = (e) => {
    const { name, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setErrMessage(null);
    setConsoleError(null);
    setFieldErrors({});
    setMissingFields([]);
    
    // Client-side check first — this never touches the server, so nothing can ever be created here
    const missing = getMissingFields(formData);
    if (missing.length > 0) {
      setMissingFields(missing);
      setErrMessage("Please fill in all required fields.");
      return;
    }

    setLoading(true);
    
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });
      if (profilePicture) {
        formDataToSend.append("profile_picture", profilePicture);
      }

      const { data } = await axiosInstance.post("register/", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setProfilePicture(null);
      setStatus("Almost done — enter the code sent to your email to complete registration.");
      navigate(`/${lang}/verify-email`, { state: { email: data.email } });

    } catch (err) {
      if (err.response && err.response.data) {
        const { fieldErrors: parsed, generalMessage } = parseServerErrors(err.response.data);
        setFieldErrors(parsed);
        setConsoleError(JSON.stringify(err.response.data));
        setError(err);
        setErrMessage(Object.keys(parsed).length > 0 ? null : ("External Server Error" || "Registration failed. Please try again."));
      } else {
        setError(err.message);
        setErrMessage("Network error — please check your connection and try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Helper for JSX: which class to apply to a given input
  function getFieldClassName(fieldName) {
    if (fieldErrors[fieldName]) return "form-field field-error";
    if (missingFields.includes(fieldName)) return "form-field field-missing";
    return "form-field";
  }

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])
  

  return (
    <>
      <NavbarLog />
      <div className="reg-page">
        {setlang === "en" ? 
        <div className="registration-container">
        <h2 className= "registration-heading">Register</h2>
          {success && <p style={{ color: 'green' }}>Registration successful! You can now log in.</p>}
          {errMessage && <pre style={{ color: 'red' }}>{errMessage}</pre>}
          <form className="form-group" onSubmit={handleSubmit}>
            
            {/*
            <input
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Username"
            className={getFieldClassName("username")}
            required
            /><br />

            <input
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              placeholder="Fist Name"
              required
            /><br />

            <input
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Last Name"
            /><br />
            */}

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              required
            /><br />
            {/*<input
              type="phone"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              placeholder="Mobile No."
            /><br />     */}       
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              required
            /><br />
            <input
              type="password"
              name="password2"
              value={formData.password2}
              onChange={handleChange}
              placeholder="Confirm Password"
              required
            /><br />
            <label>Profile Image
              <input type="file" accept="image/*" onChange={handleImageChange} placeholder="Insert Image"/>
            </label>
            <button type="submit" className='button-register' disabled={loading} >{loading ? 'Registering...' : 'Register'}</button>
            <label className="tnc-checkbox" style={{direction:"ltr"}}>
              <input
                name="accepted_tnc"
                type="checkbox"
                checked={formData.accepted_tnc}
                onChange={handleCheckBox}
                required
                />
              I accept the <Link to={`/${lang}/our-terms-and-conditions`}>Terms & Conditions</Link>
            </label>
          </form>
          <div className='login-text' >
          If you already have an account, please <Link to={`/${lang}/login`}>login here</Link>!
          </div>
        </div>
        :
        <div className="registration-container">
          <h2 className= "registration-heading">ثبت نام</h2>
            {success && <p style={{ color: 'green', marginBottom:'10px'  }}>ثبت نام با موفقیت انجام شد. حالا می‌تونی وارد حساب کاربریت بشی</p>}
            {errMessage && <pre style={{ color: 'red', marginBottom:'10px' }}>{errMessage}</pre>}
            <form className="form-group-fa" onSubmit={handleSubmit}>
              
              {/*
              <input
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="نام کاربری"
                required
              /><br />

              <input
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="نام"
                required
                /><br />

              <input
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="نام خانوادگی"
              /><br />
              */}

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="ایمیل"
                required
              /><br />
              {/*<input
                type="phone"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                placeholder="شماره موبایل"
              /><br />  */}            
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="رمز عبور"
                required
              /><br />
              <input
                type="password"
                name="password2"
                value={formData.password2}
                onChange={handleChange}
                placeholder="تکرار رمز عبور"
                required
              /><br />
              <label>
              <input type="file" accept="image/*" onChange={handleImageChange} placeholder="نمای پروفایل" style={{color:"grey"}}/>نمای پروفایل
              </label>
              <button type="submit" className='button-register' disabled={loading}>ثبت نام</button>
              <label className="tnc-checkbox">
                <input
                  name="accepted_tnc"
                  type="checkbox"
                  checked={formData.accepted_tnc}
                  onChange={handleCheckBox}
                  required
                  />
                من <Link to={`/${lang}/our-terms-and-conditions`} style={{color:"grey"}}>شرایط و ضوابط</Link> سایت را می‌پذیرم
              </label>
            </form>
            <div className='login-text' >
           !اگر دارای حساب کاربری می‌باشید، لطفا <Link to={`/${lang}/login`}>اینجا وارد شوید</Link> 
            </div>

          </div>
        }
        
        {loading && (
          <div className="loading-overlay">
            <div className="loading-box" style={{ '--spinner-size': '60px' }}>
              <div className="spinner" />
              <span>{setlang === "en" ? 'Loading...':'... در حال بارگذاری'}</span>
            </div>
          </div>
        )}

      </div> 
      <Footer />
    </>
  );
}

export default Register;
